import styled from 'styled-components'
import { breakpoint } from '@sketch/global-styles'
import { ReactComponent as FolderClosed } from '@sketch/icons/folder-closed-64'

export const ContentContainer = styled.div`
  padding-top: 20px;
`

export const Separator = styled.hr`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.border.B};
  margin: 32px -32px 32px -32px;
`

export const IconWrapper = styled.div`
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  opacity: 0.55;
  margin-bottom: 16px;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;

  ${breakpoint('base', 'xs')`
      margin-top: 16px;
      margin-bottom: 16px;
  `}
`

export const StyledFolderClosed = styled(FolderClosed)`
  color: ${({ theme }) => theme.colors.state.disabled};
`
